export const template_0001 = `
<div class="all-floors-scroll-wrapper no-scrollbar" style="width:100%;overflow-x:auto;box-sizing:border-box;">
    <style>
        .no-scrollbar {
            overflow: auto;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE 10+ */
        }

        /* Ẩn scrollbar trên Chrome, Safari */
        .no-scrollbar::-webkit-scrollbar {
            display: none;
            width: 0px;
            height: 0px;
        }

        .left-part {
            width: 30vw;
            height: 100%;
            display: block;
            opacity: 0;
        }

        .right-part {
            width: 50vw;
            height: 100%;
            display: block;
            opacity: 0;
        }
    </style>
    <div class="all-floors-inner floor-guide-drag-container"
        style="width:104.3333333334vw;display:flex;box-sizing:border-box;">
        <div class="left-part">1</div>
        <div class="floor-guide-floors" id="avenuel">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">에비뉴엘</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-1XJEftC-W5166" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">10F</span>
                <span class="floor-guide-floor-desc">스파ㅣ뷰티ㅣ치과</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-LKfYIc_0Nj5003" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">9F</span>
                <span class="floor-guide-floor-desc">타니ㅣ그라운드시소</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-WM1NKCwoa4981" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">8F</span>
                <span class="floor-guide-floor-desc">롯데시네마</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-eSNegYRQrG9851" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">7F</span>
                <span class="floor-guide-floor-desc">롯데시네마</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-m-MJ-aTVRc9665" data-x="1824"
                data-y="2000">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">롯데시네마ㅣ나이키</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-G_MooOLZ739471" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">10 꼬르소 꼬모ㅣ10 꼬르소 꼬모 카페</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-jA-1fCIJR59291" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">해외패션 l 핸드백 l 캐리어 l 구두</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-KSQB38fBI9109" data-x="1824"
                data-y="2000">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">해외보석ㅣ잡화ㅣ백화점연결</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-6PIY03fWLc8920" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">해외시계ㅣ보석</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-luCIfmyhG3441" data-x="1824" data-y="2000">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">해외부틱</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-gh61w-iPV8550" data-x="1824"
                data-y="2000">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">해외부틱ㅣ주차장ㅣ백화점연결</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="3510" data-y="2472">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="floor-guide-floors" id="main">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">본관</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-tPdd7atfFc5957" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">14F</span>
                <span class="floor-guide-floor-desc">식당가</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-RLw8qIXFV65739" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">13F</span>
                <span class="floor-guide-floor-desc">식당가</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-yHdq_C1uxo5527" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">12F</span>
                <span class="floor-guide-floor-desc">롯데면세점</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-MUEujlevLC5337" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">11F</span>
                <span class="floor-guide-floor-desc">롯데면세점</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1XJEftC-W5166" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">10F</span>
                <span class="floor-guide-floor-desc">롯데면세점</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-LKfYIc_0Nj5003" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">9F</span>
                <span class="floor-guide-floor-desc">면세점 l 키네틱 그라운드(K-패션 전문관)</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-WM1NKCwoa4981" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">8F</span>
                <span class="floor-guide-floor-desc">가전ㆍ가구ㅣ주방식기ㅣ홈데코ㅣ홈패션</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-eSNegYRQrG9851" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">7F</span>
                <span class="floor-guide-floor-desc">스포츠ㆍ아웃도어ㅣ킨더유니버스(아동ㆍ유아)</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-m-MJ-aTVRc9665" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">골프ㅣ남성컨템포러리ㅣ남성패션</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-G_MooOLZ739471" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">남성해외패션</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-jA-1fCIJR59291" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">여성패션ㅣ란제리</span>
            </div>
            <div class="floor-guide-floor small" data-id="FL-KSQB38fBI9109" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">해외슈즈ㅣ여성컨템포러리</span>
            </div>
            <div class="floor-guide-floor small" data-id="FL-6PIY03fWLc8920" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">여성해외패션</span>
            </div>
            <div class="floor-guide-floor small" data-id="FL-luCIfmyhG3441" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">화장품ㅣ해외패션</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-gh61w-iPV8550" data-x="3430" data-y="2000">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">푸드에비뉴ㅣ화장품ㅣ보석ㅣ문화센터</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-3Z8MeDieh3487" data-x="3430"
                data-y="2000">
                <span class="floor-guide-floor-name english">B2-B7</span>
                <span class="floor-guide-floor-desc">Parking Lot</span>
            </div>
        </div>
        <div class="right-part">2</div>
    </div>
</div> `;